import { Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import "./i18n.js";
import Login from './page/auth/login/login';
import LayoutMain from './component/layout/layoutMain';
import LayoutAuth from './component/layout/layoutAuth';
import ForgotPassword from './page/auth/forgotPassword/forgotPassword';
import OTPConfim from './page/auth/otpConfim/otpConfim';
import ConfimPassword from './page/auth/confimPassword/confimPassword';
import React, { useEffect, useState } from 'react';
import envInstants from "./configs/env.js";
import { setDefaultURL } from "./api/api";
import { CircularProgress } from '@mui/material';
import { getProfile, getToken } from './utils/app.utils';
import routes from './router';
import { upperCase } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { profileAsync } from './app/slice/profile.slice';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { imgs } from './constants/images';
function App() {
  const Dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const location = useLocation();
  const [isInitEnvError, setInitEnvError] = useState<boolean>(false);
  const [isInitEnv, setInitEnv] = useState<boolean>(false);
  const token = getToken();
  const { profile, loading } = useSelector((state: any) => state.profile)
  const permit = profile?.permission || []
  const basePath = routes.map((x) => {
    return {
      ...x,
      active: permit.find((y: any) => upperCase(y?.code) === upperCase(x?.code))?.permit
    }
  })
  const baseUrl = basePath.find((x) => x.active)?.path
  // const [permission, setPermission] = useState<any>([])
  // const user = getProfile() || ''
  useEffect(() => {

    if (!token) {
      navigate("/login")
    } else {
      // setPermission(permit)     
      if (location.pathname === '/' || location.pathname === '/login') {
        navigate(baseUrl)
      }
    }
  }, [token, baseUrl]);

  useEffect(() => {
    

    const loadEnv = async () => {
      try {
        await envInstants.init();
        setDefaultURL(envInstants.getConfig().baseUrl);
      } catch (error) {
        setInitEnvError(true);
      } finally {
        setInitEnv(true);
        Dispatch(profileAsync());
      }
    };

    loadEnv();
  }, [])


  if (!isInitEnv) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: "100vh" }}><CircularProgress /></div>;
  if (isInitEnvError) return <div>"Cannot load env !!!"</div>;

  function PrivateRoute() {
    return token ? <Outlet /> : <Navigate to="/login" />
  }
  return (
    <>
      <Routes>
        {
          !token ?
            [
              { path: '/login', name: 'Login', component: <Login /> },
              { path: '/forgot-password', name: 'Forgot-Password', component: <ForgotPassword /> },
              { path: '/OTP-confim', name: 'OTP-Confim', component: <OTPConfim /> },
              { path: '/confim-password', name: 'Confim-Password', component: <ConfimPassword /> },
            ].map((x: any, i: number) => {
              return <Route key={i} path={x.path} element={
                <LayoutAuth>
                  {x.component}
                </LayoutAuth>} />

            })
            : <>
              <Route element={<PrivateRoute />}>
                <> {basePath.map((x: any, i: number) => {
                  return (
                    <React.Fragment key={i}>{x.active ?
                      <Route key={x.name || i} path={x.path} element={
                        <LayoutMain>
                          {x.component && React.createElement(x.component)}
                        </LayoutMain>} /> : null}
                    </React.Fragment>)
                })}</>
                {/* <Route key={'Confim-Password'} path={'/confim-password'} element={
                  <LayoutAuth>
                    <ConfimPassword />
                  </LayoutAuth>} /> */}
              </Route>

            </>
        }
        <Route key="PageNotFound" path='*' element={
          <>
            {loading ? <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: "100vh"
            }}>
              <CircularProgress size={60} />
            </div> :
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: "100vh"
              }}>
                <img src={imgs.img404} />
              </div>}
          </>
        } />
      </Routes>
    </>
  );
}

export default App;
